import React from 'react';
import { motion } from 'framer-motion';
export function CauseSection() {
  const causes = [{
    feeling: 'Lo que sientes',
    reality: 'Lo que realmente pasa',
    isHeader: true
  }, {
    feeling: '"No puedo apagar la mente"',
    reality: 'Tu amígdala sigue activa — el cerebro cree que hay peligro'
  }, {
    feeling: '"Me despierto a las 3AM sin razón"',
    reality: 'Bajón de glucosa + cortisol elevado = alarma interna automática'
  }, {
    feeling: '"Duermo pero no descanso"',
    reality: 'Sin sueño REM profundo, el cuerpo no se restaura'
  }, {
    feeling: '"Nada me funciona"',
    reality: 'Porque las soluciones genéricas no consideran tu biología hormonal'
  }];
  return <section className="py-20 px-4 md:px-8 bg-navy-900 text-cream-100" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-16">
          <span className="text-4xl mb-4 block" data-id="element-17">🔬</span>
          <h2 className="text-gold-500 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-18">
            SECCIÓN 2 — LA CAUSA REAL
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-19">
            "El Ciclo Que Te Roba la Energía — Y Por Qué No Es Tu Culpa"
          </h3>
        </motion.div>

        <div className="prose prose-lg prose-invert mx-auto mb-12 font-body text-cream-200" data-id="element-20">
          <p className="mb-4" data-id="element-21">
            Aquí está lo que nadie te ha explicado con claridad:
          </p>
          <p className="mb-4 text-xl font-serif text-gold-400" data-id="element-22">
            Después de los 45, tu cuerpo cambia la química del sueño.
          </p>
          <p className="mb-4" data-id="element-23">
            Las hormonas menopáusicas reducen la producción natural de{' '}
            <span className="text-gold-500 font-bold" data-id="element-24">melatonina</span> — la
            hormona que te hace sentir sueño. Al mismo tiempo, el{' '}
            <span className="text-gold-500 font-bold" data-id="element-25">cortisol nocturno</span>{' '}
            sube — la hormona del estrés que te mantiene en alerta.
          </p>
          <p className="mb-4" data-id="element-26">
            El resultado: un cuerpo agotado con un sistema nervioso que sigue
            pensando que el día no terminó.
          </p>
        </div>

        {/* Causes Table */}
        <div className="grid gap-4 mb-16" data-id="element-27">
          {causes.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`grid grid-cols-1 md:grid-cols-2 gap-4 p-6 rounded-lg ${item.isHeader ? 'bg-navy-800 border-b-2 border-gold-500 font-bold hidden md:grid' : 'bg-navy-800/50 border-l-4 border-gold-500 hover:bg-navy-800 transition-colors'}`} data-id="element-28">
              <div className={`${item.isHeader ? 'text-gold-500' : 'font-serif text-lg text-cream-100'}`} data-id="element-29">
                {item.feeling}
              </div>
              <div className={`${item.isHeader ? 'text-gold-500' : 'text-cream-200'}`} data-id="element-30">
                {item.reality}
              </div>
            </motion.div>)}
        </div>

        <div className="bg-cream-100 text-navy-900 p-8 rounded-xl shadow-xl" data-id="element-31">
          <p className="mb-4" data-id="element-32">
            La melatonina de farmacia no resuelve esto. El té de manzanilla solo
            no resuelve esto. Contar respiraciones aleatorias no resuelve esto.
          </p>
          <p className="font-bold text-lg" data-id="element-33">
            Lo que resuelve esto es un sistema completo de señales — que le dice
            a tu cuerpo, paso a paso, con precisión:{' '}
            <span className="text-gold-600" data-id="element-34">
              "El día terminó. Ahora puedes restaurarte."
            </span>
          </p>
        </div>
      </div>
    </section>;
}